var _circle, _mask, _g, _circle2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultPic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#21232B"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#21232B"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 26.2,
    fill: "url(#b)",
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 26.2,
    fill: "url(#c)",
    r: 10
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.001,
    cy: 9,
    r: 5,
    transform: "rotate(-45 15 9)",
    fill: "url(#d)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 45.71,
    y1: 59.357,
    x2: 10.828,
    y2: 24.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9E9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 18.104,
    y1: 30.1,
    x2: 11.489,
    y2: 23.784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8925C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E20175"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 16.553,
    y1: 10.95,
    x2: 13.245,
    y2: 7.792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8925C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E20175"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultPic);
export default __webpack_public_path__ + "static/media/Default_Pic.d2bc621faf6531dd3c1c80839085fa34.svg";
export { ForwardRef as ReactComponent };